<template>
  <div class="">
    <div class="bg-white rounded-[24px] p-5 flex flex-col gap-4">
      <h2 class="text-[20px] font-semibold text-[#222222]">
        Қазақстан қажыларын тіркеу базасы
      </h2>

      <div
        class="bg-[#F8F1C6] rounded-[16px] px-3 relative overflow-hidden flex items-center gap-x-4"
      >
        <div class="w-28 h-28 flex-shrink-0">
          <img
            src="@/assets/images/ihram.png"
            alt="Ihram Male"
            class="w-full h-full object-cover"
          />
        </div>

        <div class="w-full flex flex-col">
          <span class="text-[14px] text-[#2B2B2B] mb-2">Тіркелген қажылар</span>
          <div class="flex gap-1 font-semibold">
            <template v-for="(digit, index) in formattedCount" :key="index">
              <div
                class="w-10 h-[43px] bg-[#FFF9D7] rounded-[9px] flex items-center justify-center shadow-[0_1px_4px_rgba(12,12,13,0.05)]"
              >
                <span class="text-[22px] text-[#222222]">{{ digit }}</span>
              </div>
            </template>
          </div>
        </div>

        <button
          class="hidden lg:block w-full bg-[#FDC903] rounded-[16px] py-4 text-[16px] font-medium text-[#222222]"
        >
          Өтінім беру
        </button>
      </div>

      <button
        class="lg:hidden w-full bg-[#FDC903] rounded-[16px] py-4 text-[16px] font-medium text-[#222222]"
      >
        Өтінім беру
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { hajiService } from "@/services";

export default defineComponent({
  name: "HajjRegister",
  data() {
    return {
      hajjCount: 0,
    };
  },
  mounted() {
    hajiService.getHajis().then((response) => {
      this.hajjCount = response.count;
    });
  },
  computed: {
    formattedCount() {
      return this.hajjCount.toString().padStart(3, "0").split("");
    },
  },
});
</script>

<style scoped lang="scss"></style>
